import type { ProductApplicationDTO } from '../api/types';
import type {
  ApplicationPlatform,
  ProductApplication,
  WebApplicationType,
} from '../model/types';

export const mapProductApplication = (
  dto: ProductApplicationDTO,
): ProductApplication => {
  return {
    id: dto.id,
    platform: dto.platform as ApplicationPlatform,
    webUrl: dto.webUrl,
    bundleId: dto.bundleId,
    name: dto.name,
    logoUrl: dto.logoUrl,
    productId: dto.productId,
    appstoreId: dto.appstoreId,
    integrationId: dto.integrationId,
    applicationType: dto.applicationType as WebApplicationType,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};
